import { AutoComplete, ISelectType } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { verticalOptions } from "./VerticalOptionValues";

const translationPath =
  "chatBot.page.register.ticketServiceWhats.whatsappProfilePath.";

export const VerticalOptions = memo(() => {
  const { t } = useTranslation();
  return (
    <Grid item xs={12} sm={12}>
      <AutoComplete
        label={t(translationPath + "vertical") || "vertical"}
        name="vertical"
        size="small"
        getOptionLabel={(option) => {
          return option.name;
        }}
        options={verticalOptions}
        filterSelectedOptions
      />
    </Grid>
  );
});
